module.exports = __webpack_public_path__ + "static/media/02290008-VSF0wSgs.70ecdfdc.JPG";